import {call, put, takeEvery} from 'redux-saga/effects';
import TotalActiveUsersApi from '../../api/TotalActiveUsersApi';
import activeUsersOverview from '../../actions/fortnite-game/activeUsersOverview.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';

function* getActiveUsersOverview(action) {
    try {
        const {data} = yield call(TotalActiveUsersApi.getDataOverview, action.payload);
        yield put(
            activeUsersOverview.getActiveUsersOverviewSuccess({
                data,
                error: data.length ? undefined : 'epic.affiliate.earnings.no_data',
                ...action.payload
            })
        );
    } catch (e) {
        yield put(
            activeUsersOverview.getActiveUsersOverviewFailed(getErrorCodeFromResponse(e), {
                ...action.payload,
                ...e
            })
        );
    }
}

function* activeUsersOverviewSaga() {
    yield takeEvery(activeUsersOverview.TYPES.GET_ACTIVE_USERS_OVERVIEW, getActiveUsersOverview);
}

export default activeUsersOverviewSaga;
